import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {ActivatedRoute, Router} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';
import {first} from 'rxjs/operators';
import {BankAccountService} from '../../../services/bank-account.service';

@Component({
    selector: 'app-bank-account-add-edit',
    templateUrl: './bank-account-add-edit.component.html',
    styleUrls: ['./bank-account-add-edit.component.scss']
})
export class BankAccountAddEditComponent implements OnInit {

    form: FormGroup;
    submitted = false;
    loading = false;
    bankAccount: any = {};
    id: number;

    constructor(
        private formBuilder: FormBuilder,
        private toastrService: ToastrService,
        private bankAccountService: BankAccountService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private spinner: NgxSpinnerService,
    ) {
    }

    ngOnInit() {
        this.form = this.formBuilder.group({
            bank_name: ['', Validators.required],
            bank_account_number: ['', Validators.required],
        });

        this.id = this.activatedRoute.snapshot.params['id'];

        if (this.id) {
            this.spinner.show();
            this.bankAccountService.getById(this.id).pipe(first()).subscribe(response => {
                this.spinner.hide();
                this.form.patchValue(response.data);
                this.bankAccount = response.data;
            }, error => {
                this.spinner.hide();
                this.router.navigate(['']);
            });
        }
    }

    get f() {
        return this.form.controls;
    }

    sendForm(): void {
        this.submitted = true;
        if (!this.form.valid) {
            return;
        }
        this.loading = true;
        let bankAccount: any = this.form.value;
        if (this.id != null) {
            bankAccount.id = this.id;
            this.bankAccountService.update(bankAccount)
                .pipe(first())
                .subscribe(response => {
                    this.loading = false;
                    this.toastrService.success(response.message, 'Éxito!');
                    this.router.navigate(['/bank-accounts']);
                }, error => {
                    this.toastrService.error(error, 'Error');
                    this.loading = false;
                });
        } else {
            this.bankAccountService.store(bankAccount)
                .pipe(first())
                .subscribe(response => {
                    this.loading = false;
                    this.toastrService.success(response.message, 'Éxito!');
                    this.router.navigate(['/bank-accounts']);
                }, error => {
                    this.toastrService.error(error, 'Error');
                    this.loading = false;
                });
        }
    }
}
